import React from "react";

function EmptyCart() {
  return (
    <li className="flex flex-col items-center justify-center gap-12 p-20 text-center md:p-28 lg:p-36">
      <div>
        <h3 className="text-md mb-6 font-semibold">Your cart is empty</h3>
        <button className="bg-black px-4 py-2 text-base text-white">
          Continue shopping
        </button>
      </div>
      <div>
        <h6 className="mb-2 text-base font-semibold">Have an account?</h6>
        <div className="text-base font-light">Log in to check out faster.</div>
      </div>
    </li>
  );
}

export default EmptyCart;
